import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=10d7c09d&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=10d7c09d&prod&scoped=scoped&lang=less"
import style1 from "./Update.vue?vue&type=style&index=1&id=10d7c09d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d7c09d",
  null
  
)

export default component.exports